import { bool, func, node, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';
import { Button, Modal, Stack } from '@chaser/components';
import { ErrorIcon, SuccessIcon } from '../../../assets/alert-icons/index';
import style from './ModalAlert.module.scss';

const Popup = ({
  open,
  message = '',
  title,
  toggle,
  type = 'success',
  error,
  label = 'Ok',
  onClosed = () => {},
  ...rest
}) => (
  <Modal
    size="small"
    open={open}
    toggle={toggle}
    onClosed={onClosed}
    body={
      <Stack className={style.body} alignItems="center">
        {type === 'success' && <img src={SuccessIcon} alt="" />}
        {type === 'error' && <img src={ErrorIcon} alt="" />}
        {title && <div className={style.title}>{title}</div>}
        {message && <div className={style.message}>{message}</div>}
        {type === 'error' && error && <div className={style.message__error}>{error}</div>}
      </Stack>
    }
    footer={
      <div className={style.footer}>
        <Button
          onClick={() => {
            toggle(false);
          }}
        >
          {label}
        </Button>
      </div>
    }
    {...rest}
  />
);

export default Popup;

Popup.propTypes = {
  onClosed: func,
  label: string,
  error: string,
  onClose: func,
  onOpen: func,
  type: oneOf(['success', 'error']),
  toggle: func.isRequired,
  open: bool.isRequired,
  message: oneOfType([string, node]),
  title: string,
};
